import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import 'rc-pagination/assets/index.css';
import { getOobLogs } from '../../../actions/OobLogs';
import logoLoading from '../../../Res/logo-loading.gif';
import { useSelector } from 'react-redux';
import utils from '../../../lib/utils';
import { ENG_LOCALE } from '../../../lib/constants';
import Pagination from 'rc-pagination';
import SetLimitEntries from '../../../components/SetLimitEntries';
import { Row } from 'reactstrap';

const TH = (props) => (
  <th className="cursor-pointer" style={props?.style} {...props}>
    {props.label ? props.label : props.children}
  </th>
)
const OobLogTable = () => {
  const dispatch = useDispatch();

  const user = useSelector(state => state.AppState.user)
  const token = localStorage.getItem('jwtToken') || null;

  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);

  const fetchOobLogs = async (page = 1, limit = 10,) => {
    setLoading(true);
    const pagination = { page, limit, sort: { createdAt: -1 } }
    const result = await dispatch(getOobLogs(token, user._id, pagination));
    setListData(result);
    setLoading(false);
  };

  useEffect(() => {
    fetchOobLogs();
  }, []);

  return loading ? (
    <div className="error-msg d-flex flex-column justify-content-center align-items-center">
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
      <p className="text-align-center">Loading, Please wait...</p>
    </div>
  ) : (
    <>
      <div className="table-header-fixed">
        <table>
          <thead>
            <tr>
              <TH label={'Serial Number'} />
              <TH label={'Device'} />
              <TH label={'User'} />
              <TH label={'Description'} style={{ width: '500px' }} />
              <TH label={'Created At'} />
            </tr>
          </thead>
          <tbody>
              {listData?.docs?.map(element => (
              <tr>
                <td>{element?.box}</td>
                <td>{element?.boxDisplayName}</td>
                <td>{element?.user}</td>
                <td className="action-description">
                  {element.description}
                </td>
                <td>
                  {utils.getDateTimeFormat(element?.createdAt, 'both')}
                </td>
              </tr>
            ))}
            {listData.length === 0 &&
              <td colSpan={5}><h2 className='no-usb-text'><span>No session on device</span></h2></td>
            }
          </tbody>
        </table>
          {listData && (listData?.docs?.length > 0) ? (
            <Row className="justify-content-md-center mt-3 w-100">
              <SetLimitEntries
                value={listData.limit || 10}
                onChange={limit => {
                  fetchOobLogs(1, limit);
                }}
              />

              <Pagination
                locale={ENG_LOCALE}
                className="pagination-container"
                onChange={page => {
                  fetchOobLogs(page, listData.limit);
                }}
                current={listData.page}
                total={listData.totalDocs}
                pageSize={listData.limit}
                showLessItems
                showTitle={false}
                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
              />
            </Row>
          ) : (
            <Row className="justify-content-md-center">
              <div className="select-limit">No logs found</div>
            </Row>
          )}
      </div>
    </>
  );
};

export default OobLogTable;
